import { Box, Badge } from "@material-ui/core";
import {
  ActionLink,
  BackButton,
  DatePickerButton,
  Header,
  Icon,
  IconName,
  MobileSearchFieldButton,
} from "halifax";
import React, { useContext } from "react";
import { RouteComponentProps } from "react-router-dom";

import { useIsTravelApp } from "@capone/common";
import clsx from "clsx";
import { PATH_HOME } from "../../../../utils/paths";

import { MobileEditLocationsModal } from "../MobileEditLocationsModal";
import { MobileLocationSelectionConnectorProps } from "./container";
import { MobileCalendarPickerModal } from "../MobileCalendarPickerModal";
import { TravelWalletDrawer } from "../../../travel-wallet/components";
import "./styles.scss";
import { ClientContext } from "../../../../App";

interface IMobileLocationSelectionProps
  extends RouteComponentProps,
    MobileLocationSelectionConnectorProps {}

export const MobileLocationSelection = (
  props: IMobileLocationSelectionProps,
) => {
  const {
    history,
    departureDate,
    returnDate,
    destination,
    setOpenDatesModal,
    walletItemCount,
    datesModalOpen,
  } = props;
  const [locationModalOpen, setLocationModalOpen] =
    React.useState<boolean>(false);
  const [travelWalletDrawerOpen, setTravelWalletDrawerOpen] =
    React.useState<boolean>(false);

  const { isTravelApp } = useIsTravelApp();

  const handleOpenCalendarModal = (open: boolean) => {
    setOpenDatesModal(open);
  };

  const { showCoreHomepage } = useContext(ClientContext);

  return (
    <>
      <Header
        className={clsx("mobile-pkg-hotel-availability-search-header", {
          "core-homepage": showCoreHomepage,
        })}
        left={
          isTravelApp ? undefined : (
            <BackButton
              className="mobile-hotel-availability-go-back"
              onClick={() => history.push(PATH_HOME)}
            />
          )
        }
        center={
          <Box className="mobile-hotel-availability-search-and-date">
            <MobileSearchFieldButton
              value={destination?.label}
              // value={isSearchingMap ? "Map area" : destination?.label}
              onClick={() => setLocationModalOpen(true)}
            />
            <DatePickerButton
              startDate={departureDate}
              endDate={returnDate}
              classes={["hotel-inline-juncture-input"]}
              renderCalendarPopup={() => (
                <MobileCalendarPickerModal
                  openCalendarModal={datesModalOpen}
                  setOpenCalendarModal={handleOpenCalendarModal}
                  fullScreen
                  searchOnContinue
                />
              )}
              onClick={() => handleOpenCalendarModal(true)}
              dateFormat="MMM D"
              variant="minimal"
            />
          </Box>
        }
        right={
          !showCoreHomepage || isTravelApp ? (
            <ActionLink
              className="mobile-hotel-availability-wallet-entry"
              onClick={() => setTravelWalletDrawerOpen(true)}
              content={
                <Badge
                  className="wallet-count"
                  badgeContent={walletItemCount ? "" : undefined}
                >
                  <Icon name={IconName.TravelWalletIcon} />
                </Badge>
              }
            />
          ) : undefined
        }
      />
      <MobileEditLocationsModal
        openLocationModal={locationModalOpen}
        setOpenLocationModal={setLocationModalOpen}
        setOpenCalendarModal={setOpenDatesModal}
      />
      <TravelWalletDrawer
        drawerOpen={travelWalletDrawerOpen}
        setDrawerOpen={setTravelWalletDrawerOpen}
      />
    </>
  );
};
